// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5610) return "static/chunks/5610-build-1754871833791-86996bde807fcb70.js";
	if (chunkId === 2626) return "static/chunks/2626-build-1754871833791-3c0675092693b37b.js";
	if (chunkId === 8030) return "static/chunks/8030-build-1754871833791-ff52f6a06c82a940.js";
	if (chunkId === 5571) return "static/chunks/5571-build-1754871833791-d0ba0078f48871e9.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-build-1754871833791." + {"354":"da0964e9b81dc6ea","3296":"b90e3c9f2a178967","6483":"ea179917cbb0b46b","8096":"696c7590a859e77b","8241":"17dd5e444bba3864","8505":"ef29edf046643b27","8847":"4b6ca7a8c2a2294d","9443":"aff9d73ba872d0f7"}[chunkId] + ".js";
};